import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d47ff1b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "riquadroScratch" }
const _hoisted_2 = {
  class: "base",
  ref: "base"
}
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "itemWonImage",
        src: _ctx.itemWonImage
      }, null, 8, _hoisted_3)
    ], 512),
    _createElementVNode("canvas", {
      id: "scratch",
      ref: "scratch",
      onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onMousedown && _ctx.onMousedown(...args))),
      onMousemove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMousemove && _ctx.onMousemove(...args))),
      onMouseup: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onMouseup && _ctx.onMouseup(...args))),
      onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onMouseleave && _ctx.onMouseleave(...args))),
      onTouchstart: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onTouchstart && _ctx.onTouchstart(...args))),
      onTouchmove: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onTouchmove && _ctx.onTouchmove(...args))),
      onTouchend: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onTouchend && _ctx.onTouchend(...args)))
    }, null, 544)
  ]))
}